import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class SegmentService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Segment';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'segment/0', 'title': 'Segment News', 'theme': 'layout1' },
      { 'url': 'segment/1', 'title': 'Segment Card With Avatar', 'theme': 'layout2' },
      { 'url': 'segment/2', 'title': 'Segment Card With Big Image', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Segment List',
      'segmentButton1': 'new cars',
      'segmentButton2': 'old cars',
      // Data Page 1
      'page1': {
        'headerImage': 'assets/imgs/background/7.jpg',
        'title': 'Mercedes-AMG GT?',
        'category': 'Cars',
        'shareIcon': 'ellipsis-vertical',
        'button': 'Buy Now',
        'price': '$ 100',
        'priceTitle': 'per month',
        'image1': 'assets/imgs/background/1.jpg',
        'image2': 'assets/imgs/background/3.jpg',
        'image3': 'assets/imgs/background/5.jpg',
        'description1': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
        'description2': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            'title': 'Mercedes-AMG GT',
            'subtitle': '2 in stock',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/2.jpg',
            'button': 'Book Now',

          },
          {
            'id': 2,
            'title': 'Porsche 911',
            'subtitle': '2 in stock',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/4.jpg',
            'button': 'Book Now',
          },
          {
            'id': 3,
            'title': 'Ford Mustang Shelby GT350',
            'subtitle': '2 in stock',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/6.jpg',
            'button': 'Book Now',
          },
          {
            'id': 4,
            'title': 'BMW Z4',
            'subtitle': '2 in stock',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/5.jpg',
            'button': 'Book Now',
          }
        ]
      }
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Segment Card With Avatar',
      'segmentButton1': 'Best Sport Sedans',
      'segmentButton2': 'Best Hot Hatche',
      'segmentButton3': 'Best Sports Convertibles',
      // Data Page 1
      'page1': {
        'items': [
          {
            'id': 1,
            "title": "Mazda MX-5 Miata",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/1.jpg",
          },
          {
            'id': 2,
            "title": "Toyota Supra",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/2.jpg",
          },
          {
            'id': 3,
            "title": "Chevy Corvette",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/3.jpg",
          },
          {
            'id': 4,
            "title": "Porsche 718 Cayman",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/4.jpg",
          },
          {
            'id': 5,
            "title": "Porsche 718 Boxster",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/9.jpg",
          },
          {
            'id': 6,
            "title": "BMW M2",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/10.jpg",
          },
          {
            'id': 7,
            "title": "BMW Z4",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/11.jpg",
          },
          {
            'id': 8,
            "title": "Ford Mustang Shelby GT350",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/12.jpg",
          }
        ]
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            "title": "Porsche 911",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/8.jpg",
          },
          {
            'id': 2,
            "title": "Porsche 911",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/7.jpg",
          },
          {
            'id': 3,
            "title": "McLaren 600LT",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/6.jpg",
          },
          {
            'id': 4,
            "title": "Porsche 718 Boxster",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/5.jpg",
          },
          {
            'id': 5,
            "title": "Porsche 718 Cayman",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/12.jpg",
          },
          {
            'id': 6,
            "title": "Porsche 718 Boxster",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/11.jpg",
          },
          {
            'id': 7,
            "title": "BMW M2",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/10.jpg",
          },
          {
            'id': 8,
            "title": "BMW Z4",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/9.jpg",
          }
        ]
      },
      // Data Page 2
      'page3': {
        'items': [
          {
            'id': 1,
            "title": "Ford Mustang Shelby GT350",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/9.jpg",
          },
          {
            'id': 2,
            "title": "Porsche 718 Boxster",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/11.jpg",
          },
          {
            'id': 3,
            "title": "Porsche 718 Cayman",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/10.jpg",
          },
          {
            'id': 4,
            "title": "Toyota Supra",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/12.jpg",
          },
          {
            'id': 5,
            "title": "Mazda MX-5 Miata",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/8.jpg",
          },
          {
            'id': 6,
            "title": "Mercedes-AMG GT",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/11.jpg",
          },
          {
            'id': 7,
            "title": "Porsche 911",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/10.jpg",
          },
          {
            'id': 8,
            "title": "Ford Mustang Shelby GT350",
            "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "image": "assets/imgs/avatar/9.jpg",
          }
        ]
      }
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Segment Card With Big Image',
      'segmentButton1': 'New Sports Cars ',
      'segmentButton2': 'Best Sports Cars',
      // Data Page 1
      'page1': {
        'items': [
          {
            'id': 1,
            'title': 'Ford Mustang Shelby GT350',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 20 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/5.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 2,
            'title': 'BMW Z4',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 700 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/6.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 3,
            'title': 'Porsche 718 Boxster',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/7.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 4,
            'title': 'Porsche 718 Cayman',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 500 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/1.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
        ]
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            'title': 'Chevy Corvette',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 20 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/2.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 2,
            'title': 'Toyota Supra',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 700 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/3.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 3,
            'title': 'Mazda MX-5 Miata',
            'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/4.jpg',
            'icon': 'heart',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          }
        ]
      }
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('segment/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
